import { useEffect } from 'react';
import { Router } from 'wouter';
import { useBrowserLocation } from 'wouter/use-browser-location';

import FullScreenModal from '@/ui/components/full-screen-modal';
import WalletSnapshot from '@/ui/components/wallet-snapshot';
import exodus from '@/ui/exodus';
import useIsCollapsed from '@/ui/hooks/use-is-collapsed';
import useMemoryLocation from '@/ui/hooks/use-memory-location';
import usePromptInstall from '@/ui/hooks/use-prompt-install';
import Routes from '@/ui/routes';
import { cn } from '@/ui/utils/classnames';
import DisconnectMessageHandler from './components/disconnect-message-handler/disconnect-message-handler.js';
import useIsLocked from './hooks/use-is-locked.js';
import useTrackFirstFund from './hooks/use-track-first-fund.js';

function App() {
  const isCollapsed = useIsCollapsed();

  const isLocked = useIsLocked();

  useTrackFirstFund();
  usePromptInstall();

  useEffect(() => {
    if (isLocked) {
      return;
    }

    exodus.analytics.track({
      event: 'AppSession',
    });

    // Prefetch exchange assets when wallet is unlocked.
    exodus.exchange.prefetchPairs();
  }, [isLocked]);

  useEffect(() => {
    if (__STANDALONE_MODE__ || isLocked) {
      return;
    }

    exodus.analytics.track({
      event: isCollapsed ? 'WalletWidgetCollapse' : 'WalletWidgetExpand',
    });
  }, [isLocked, isCollapsed]);

  return (
    <>
      {!__STANDALONE_MODE__ && <DisconnectMessageHandler />}

      {isCollapsed && <WalletSnapshot />}

      <div
        className={cn(
          'h-full overflow-hidden',
          isCollapsed ? 'hidden' : 'block',
        )}
      >
        <FullScreenModal />
        <Router
          hook={__STANDALONE_MODE__ ? useBrowserLocation : useMemoryLocation}
        >
          <Routes />
        </Router>
      </div>
    </>
  );
}

export default App;
